<template lang='pug' src='./header.pug'></template>

<script>
import Icon from 'components/icon/icon'
import ContactForm from 'components/form/form'

export default {
  computed: {
    props () {
      return this.$store.state.app['header']
    },
    propsfoot () {
      return this.$store.state.app['footer']
    }
  },
  methods: {
    welcome1Click () {
      this.$router.push('/')
      setTimeout(() => {
        this.$scrollTo('#our-doctor')
      },
      500)
    },
    welcome2Click () {
      this.$router.push('/')
      setTimeout(() => {
        this.$scrollTo('#our-team')
      },
      500)
    },
    welcome3Click () {
      this.$router.push('/')
      setTimeout(() => {
        this.$scrollTo('#our-testimonials')
      },
      500)
    },
    treatment1Click () {
      this.$router.push('/your-perfect-treatment')
      setTimeout(() => {
        this.$scrollTo('#perfectlist0')
      },
      500)
    },
    treatment2Click () {
      this.$router.push('/your-perfect-treatment')
      setTimeout(() => {
        this.$scrollTo('#perfectlist1')
      },
      500)
    },
    treatment3Click () {
      this.$router.push('/your-perfect-treatment')
      setTimeout(() => {
        this.$scrollTo('#perfectlist2')
      },
      500)
    },
    treatment4Click () {
      this.$router.push('/your-perfect-treatment')
      setTimeout(() => {
        this.$scrollTo('#perfectlist3')
      },
      500)
    },
    smile1Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament0___BV_tab_button__').click()
      },
      500)
    },
    smile2Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament1___BV_tab_button__').click()
      },
      500)
    },
    smile3Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament2___BV_tab_button__').click()
      },
      500)
    },
    smile4Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament3___BV_tab_button__').click()
      },
      500)
    },
    smile5Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament4___BV_tab_button__').click()
      },
      500)
    },
    smile6Click () {
      this.$router.push('/creating-your-smile')
      setTimeout(() => {
        this.$scrollTo('#treamentall')
        document.getElementById('treament5___BV_tab_button__').click()
      },
      500)
    }
  },
  components: {
    Icon,
    ContactForm
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?bd0b1b72